<template>
  <section>
    <popup v-show="hasPopup"
           :popup-type="getPopupType"
           :popup-action="getPopupAction"
           @popup-action="executePopupAction"></popup>
    <div class="status" v-if="isEditable">
      <h2 v-translate>IP Prefixy</h2>
      <a
                    :title="'Přidat IP prefix' | translate"
          :class="['add', 'add_expand', { open: newIpPrefixOpen }, { btn_inactive: false}]"
          @click.prevent="toggleNewIpPrefix()"
          v-translate>Přidat IP prefix
      </a>
    </div>
    <div :class="['filter', 'expand_content', { open: newIpPrefixOpen }]">
      <div class="field_left">
        <p>
          <text-input
              id="ipPrefix-name-add"
              v-model="newIpPrefix"
              :required="true"
              ref="localitynewipprefixnameref"
          >
            <translate class="translate">IP prefix</translate>
          </text-input>
        </p>
        <p v-if="allowSelectOperator">
          <select-box
              id="operator_prefixes"
              v-model="idOperator"
              :options="operatorListOptions"
              ref="localitynewipprefixoperatorref"
          >
            <translate class="translate">Operátor</translate>
          </select-box>
        </p>
      </div>
      <div class="field_right field_btn">
        <p class="field">
          <input
              type="submit"
              class="btn"
              :value="'Uložit' | translate"
              @click.prevent.stop="addIpPrefix"
          />
        </p>
      </div>
    </div>

    <form>
      <div class="scroll-wrapper">
        <div class="table_overflow" id="contentBox" data-table-id="localities-ip-prefixes">
          <table class="vypis" ref="table_with_action_line">
      <thead class="no_sortable">
      <tr v-if="prefixesPaginated.length > 0">
        <th class="first_data" v-translate>IP prefix</th>
        <th  v-translate>Operátor</th>
        <th></th>
        <th class="no_padding edit"></th>
      </tr>
      </thead>
      <ip-prefix-row
          v-for="prefix in prefixesPaginated"
          :key="prefix.id"
          :item="prefix"
          :isEditable="isEditable"
          @updateIpPrefix="updateIpPrefix"
          @deleteIpPrefix="deleteIpPrefix"
          :ref="'localityipprefixrow'+prefix.id"
      ></ip-prefix-row>
      <tr v-if="prefixesPaginated.length === 0">
           <td colspan="8">{{ $gettext('Nebyly nalezeny žádné IP prefixy.') }}</td>
      </tr>

    </table>
        </div>
      </div>
    <list-action-line
        :entities="entities"
        :offset="formFields.offset"
        :limit="formFields.limit"
        :total-count="rowCount"
        table-id="localities-ip-prefixes"
        @limit="setLimit"
        @offset="setOffset"
        ref="action_line"
    ></list-action-line>
    </form>
  </section>
</template>
<script>
import IpPrefixRow from "@/components/views/localities/locality/IpPrefixesRow";
import listActions from "@/components/mixins/list-actions";
import localities from "../mixins/localities";

export default {
  name: "IpPrefixesList",
  components: {
    IpPrefixRow,
  },
  mixins: [listActions, localities],
  props: {
    isEditable: Boolean,
    localityId: {type: Number},
    localityIdOperator: Number|null,
    ipPrefixes: {
      type: Array,
      default: () => {
        return [];
      }
    },
    operatorOptions: Array
  },
  data() {
    return {
      newIpPrefixOpen: false,
      newIpPrefix: null,
      idOperator: this.localityIdOperator
    };
  },
  created(LocalityService) {
    this.entityService = LocalityService;
  },
  computed: {
    operatorListOptions(){
      return this.operatorOptions.filter(item => {
        return item.id != -1;
      });
    },
    prefixesPaginated() {
      return this.ipPrefixes.slice(this.formFields.offset, this.formFields.offset + this.formFields.limit);
    },
    rowCount() {
      return this.ipPrefixes.length;
    },
    allowSelectOperator(){
      return this.isEditable && this.$_updateActionAllowedAllOrOwnAndGlobal && this.localityIdOperator == null;
    }
  },
  methods: {
    toggleNewIpPrefix() {
      this.emptyMessage();
      this.newIpPrefixOpen = !this.newIpPrefixOpen;
      if (this.newIpPrefixOpen) {
        this.$refs['localitynewipprefixnameref'].setForcedInvalid(false);
        this.newIpPrefix = null;
      }
    },
    addIpPrefix() {
      this.entityService.addIpPrefixToLocality(
          {
            id_locality: this.localityId,
            ip_prefix: this.newIpPrefix,
            id_operator: this.idOperator})
          .then(() => {
            this.emptyMessage();
            this.setSuccessMessage();
            this.$emit('reload-entity');
            this.toggleNewIpPrefix();
          })
          .catch(function (error) {
            this.setErrorMessage(this.processErrorMessage(error));
          }.bind(this));
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/views/localities/locality/IpPrefixesList.vue